/**
 * Catalog Schema
 * IDP Tools catalog and marketplace tables
 */

import { pgTable, uuid, varchar, text, timestamp, boolean, integer } from 'drizzle-orm/pg-core';
import { relations } from 'drizzle-orm';
import { profiles } from './profiles';

// =============================================================================
// IDP Tools Catalog
// =============================================================================
export const idpToolsCatalog = pgTable('idp_tools_catalog', {
  id: uuid('id').primaryKey().defaultRandom(),
  name: varchar('name', { length: 255 }).notNull(),
  description: text('description').notNull(),
  category: varchar('category', { length: 100 }).notNull(),
  subcategory: varchar('subcategory', { length: 100 }),
  vendor: varchar('vendor', { length: 255 }),
  websiteUrl: text('website_url'),
  documentationUrl: text('documentation_url'),
  githubUrl: text('github_url'),
  logoUrl: text('logo_url'),
  pricingModel: varchar('pricing_model', { length: 50 }),
  maturityLevel: varchar('maturity_level', { length: 50 }),
  communitySize: varchar('community_size', { length: 50 }),
  integrationComplexity: varchar('integration_complexity', { length: 50 }),
  popularityScore: integer('popularity_score'),
  supportedPlatforms: text('supported_platforms'), // JSON array
  supportedLanguages: text('supported_languages'), // JSON array
  deploymentTypes: text('deployment_types'), // JSON array
  enterpriseFeatures: text('enterprise_features'), // JSON
  tags: text('tags'), // JSON array
  isVerified: boolean('is_verified').default(false),
  lastUpdated: timestamp('last_updated'),
  createdBy: uuid('created_by'),
  createdAt: timestamp('created_at').defaultNow().notNull(),
  updatedAt: timestamp('updated_at').defaultNow().notNull(),
});

// =============================================================================
// Relations
// =============================================================================
export const idpToolsCatalogRelations = relations(idpToolsCatalog, ({ one }) => ({
  createdByUser: one(profiles, {
    fields: [idpToolsCatalog.createdBy],
    references: [profiles.id],
  }),
}));

// =============================================================================
// Types
// =============================================================================
export type IdpToolsCatalogEntry = typeof idpToolsCatalog.$inferSelect;
export type NewIdpToolsCatalogEntry = typeof idpToolsCatalog.$inferInsert;
